module.exports = __webpack_public_path__ + "img/wewm.1257706b.jpg";